import web from "../web";

class PeriodicitesScolairesService {
    index(token){
        return web.get("/api/periodicitesscolaires", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/periodicitesscolaires", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/periodicitesscolaires/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/periodicitesscolaires/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/periodicitesscolaires/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new PeriodicitesScolairesService()